/* eslint-disable no-unused-vars */
import {
  
} from '@/store/modules/bs_set/mutations'

import bsSet from '../../../apis/bsSet' 

export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const GET_FAVORITE_AREA = 'GET_FAVORITE_AREA'
export const GET_FAVORITE_LOCATION = 'GET_FAVORITE_LOCATION'
export const GET_INTEREST_LIST = 'GET_INTEREST_LIST'
export const ADD_FAVORITE_AREA = 'ADD_FAVORITE_AREA'
export const ADD_INTEREST_LIST = 'ADD_INTEREST_LIST'

export default {

  [UPDATE_PROFILE]({ commit }, data) {
    return bsSet.updateProfile(data)
  },
  [GET_FAVORITE_AREA]({ commit }, data) {
    return bsSet.getFavoriteArea(data)
  },
  [GET_FAVORITE_LOCATION]({ commit }, data) {
    return bsSet.getFavoriteLocation(data)
  },
  [GET_INTEREST_LIST]({ commit }, data) {
    return bsSet.getInterestList(data)
  },
  [ADD_FAVORITE_AREA]({ commit }, data) {
    return bsSet.addFavoriteArea(data)
  },
  [ADD_INTEREST_LIST]({ commit }, data) {
    return bsSet.addInterestList(data)
  }

}